import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #8c8c8c;
`

// TODO Remove the onClick!
const EditSmall = ({ onClick, title = 'Edit', ...rest }: IconProps & { onClick: () => void }) => (
  <StyledIcon onClick={onClick} viewBox="0 0 16 16" title={title} {...rest}>
    <g fill="currentColor">
      <path d="M8.1 3.5L.3 11.3c-.2.2-.3.4-.3.7v3c0 .6.4 1 1 1h3c.3 0 .5-.1.7-.3l7.8-7.8-4.4-4.4z" />
      <path d="M15.7 3.3l-3-3c-.4-.4-1-.4-1.4 0L9.5 2.1l4.4 4.4 1.8-1.8c.4-.4.4-1 0-1.4z" />
    </g>
  </StyledIcon>
)

EditSmall.displayName = 'EditSmall'
EditSmall.needsWork = true
export default EditSmall
